import type { FC } from 'react';
import React from 'react';
import type { FooterProps } from './ui';
import FooterUi from './ui';
import { EXTERNAL_ROUTES } from '@ab-core/functions';

const socialmedia: FooterProps['socialmedia'] = [
    {
        iconname: 'Facebook',
        link: EXTERNAL_ROUTES.FACEBOOK
    },
    {
        iconname: 'Youtube',
        link: EXTERNAL_ROUTES.YOUTUBE
    },
    {
        iconname: 'Xing',
        link: EXTERNAL_ROUTES.XING
    },
    {
        iconname: 'Linkedin',
        link: EXTERNAL_ROUTES.LINKEDIN
    },
    {
        iconname: 'Instagram',
        link: EXTERNAL_ROUTES.INSTAGRAM
    }
];

const links: FooterProps['links'] = [
    {
        name: 'Impressum',
        link: '/impressum'
    },
    {
        name: 'Datenschutz',
        link: '/datenschutz'
    },
    {
        name: 'AGB',
        link: '/agb'
    },
    {
        name: 'Zertifikate',
        link: '/zertifikate'
    },
    {
        name: 'Newsletter anmelden',
        link: EXTERNAL_ROUTES.NEWSLETTER
    }
];

const Footer: FC = () => <FooterUi homelink="/" socialmediaColor="primary" socialmedia={socialmedia} links={links} />;

export default Footer;
